const React = require('react');
const PropTypes = require('prop-types');
const parser = require('ua-parser-js');
import { IMAGES } from 'utilities/devices';

class GridDevicesImage extends React.Component {

    constructor(props) {
        super(props);
    }

    resolveOnline = (device) => {
        return device.sessions && device.sessions[0] && device.sessions[0].active ? 'Online' : '';
    }

    resolveIconType(device){
        if (device.type === 'MOBILE') {
            switch (device.platform) {
                case 'ANDROID':
                    return 'iconPhoneAndroid'
                case 'IOS':
                    return 'iconPhoneIos'
                default:
                    return 'iconPhone'
            }
        } else if(device.version) {
            const ua = parser(device.version)
            const name = ua.browser.name
            const type = ua.device.type

            if ((/Chrome/).test(name))
                return type === 'tablet' ? 'iconTabletChrome' : 'iconLaptopChrome'
            if ((/Firefox/).test(name))
                return type === 'tablet' ? 'iconTabletFirefox' : 'iconLaptopFirefox'
            if ((/Edge|IE/).test(name))
                return type === 'tablet' ? 'iconTabletExplorer' : 'iconLaptopExplorer'
            if ((/Safari/).test(name))
                return type === 'tablet' ? 'iconTabletSafari' : 'iconLaptopSafari'
            return (type === 'tablet') ? 'iconTablet' : 'iconLaptop'
        } else {
            return 'iconLaptop'
        }
    }

    resolveImage = (device) => {
        return IMAGES[`${this.resolveIconType(device)}${device.blocked ? 'Block' : ''}${this.resolveOnline(device)}${device.forgotten ? 'Light' : ''}`]
    }

    render() {
        const { device } = this.props

        return (
            <img src={this.resolveImage(device)} className="icon-device"/>
        );
    }
}

GridDevicesImage.propTypes = {
    device: PropTypes.object
}

GridDevicesImage.defaultProps = {
    device: {}
}

module.exports.constructor = GridDevicesImage
module.exports.GridDevicesImage = GridDevicesImage